// @flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { usePreviewBulkMetaRowsStyles } from './styles';

type RowToRenderItemType = {
  enabled: boolean,
  RowProps?: Object,
  title: string,
  render: Node
};

type PreviewBulkMetaRowsType = {
  rowsToRender?: Array<RowToRenderItemType>
};

const PreviewBulkMetaRows = ({ rowsToRender = [] }: PreviewBulkMetaRowsType) => {
  const classes = usePreviewBulkMetaRowsStyles();
  const filteredRows = rowsToRender.filter(row => row.enabled);

  return filteredRows.map(row => (
    <Grid
      data-testid="bulk-meta-row"
      key={row.title}
      container
      item
      alignItems="center"
      wrap="nowrap"
      className={classes.previewBulkRow}
      {...row.RowProps}
    >
      <Grid item className={classes.title}>
        <Typography variant="body2" className={classes.titleItem}>
          {row.title}:
        </Typography>
      </Grid>
      <Grid item>
        {typeof row.render === 'string' ? (
          <Typography variant="body2">{row.render}</Typography>
        ) : (
          row.render
        )}
      </Grid>
    </Grid>
  ));
};

export default PreviewBulkMetaRows;
